import React, { FC } from 'react';

import { BORDER_RADIUS } from '@app/style/constants';
import wipIMG from '@assets/general/wip.png';
import { Container } from '@styled/shared/Container';
import { Image, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { t } from 'i18next';

const { Text } = Typography;

interface IWIPLayoutProps {
	title?: string;
	description?: string;
}

const WIPLayout: FC<IWIPLayoutProps> = ({
	title = t('common.wipTitle'),
	description = t('common.wipDescription'),
}) => (
	<Container vertical gap={16} align='center' style={{ textAlign: 'center' }}>
		<Image preview={false} src={wipIMG} style={{ maxWidth: 750, borderRadius: BORDER_RADIUS }} />
		<Title level={2}>{title}</Title>
		<Text className='text-gray'>{description}</Text>
	</Container>
);

export default WIPLayout;
